import {
  progress_ring_styles_default
} from "./chunk.ASKAAAZQ.js";
import {
  LocalizeController
} from "./chunk.RQU6SOEM.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/progress-ring/progress-ring.ts
var FadvProgressRing = class extends s {
  constructor() {
    super(...arguments);
    this.localize = new LocalizeController(this);
    this.label = "";
    this.value = 0;
  }
  getStyle() {
    let style = "";
    if (this.strokeWidth) {
      style += `--track-width: ${this.strokeWidth}px;`;
    }
    if (this.size) {
      style += `--size: ${this.size}px;`;
    }
    style += `--percentage: ${this.value / 100}`;
    return style;
  }
  render() {
    return $`<div part="base" class=${o({
      "progress-ring": true,
      "progress-ring--primary": !this.variant || this.variant === "primary",
      "progress-ring--secondary": this.variant === "secondary",
      "progress-ring--tertiary": this.variant === "tertiary",
      "progress-ring--neutral": this.variant === "neutral",
      "progress-ring--success": this.variant === "success",
      "progress-ring--warning": this.variant === "warning",
      "progress-ring--danger": this.variant === "danger"
    })} role="progressbar" aria-label=${this.label.length > 0 ? this.label : this.localize.term("progress")} aria-valuemin="0" aria-valuemax="100" aria-valuenow="${this.value ? this.value : 0}" style="${this.getStyle()}" ><svg class="progress-ring__image"><linearGradient id=${`gradient-${this.variant}`}><stop offset="5%" class="gradient-start" /><stop offset="95%" class="gradient-stop" /></linearGradient><circle class="progress-ring__track"></circle><circle class="progress-ring__indicator" stroke=${`url(#gradient-${this.variant})`}></circle></svg><span part="label" class="progress-ring__label"><slot></slot></span></div>`;
  }
};
FadvProgressRing.styles = progress_ring_styles_default;
__decorateClass([
  i(".progress-ring")
], FadvProgressRing.prototype, "progressRing", 2);
__decorateClass([
  i(".progress-ring__indicator")
], FadvProgressRing.prototype, "indicator", 2);
__decorateClass([
  e()
], FadvProgressRing.prototype, "label", 2);
__decorateClass([
  e()
], FadvProgressRing.prototype, "size", 2);
__decorateClass([
  e()
], FadvProgressRing.prototype, "strokeWidth", 2);
__decorateClass([
  e()
], FadvProgressRing.prototype, "lang", 2);
__decorateClass([
  e({ reflect: true })
], FadvProgressRing.prototype, "variant", 2);
__decorateClass([
  e({ type: Number, reflect: true })
], FadvProgressRing.prototype, "value", 2);
FadvProgressRing = __decorateClass([
  n("fadv-progress-ring")
], FadvProgressRing);

export {
  FadvProgressRing
};
